module.exports = __webpack_public_path__ + "img/level_txt_3.c448aea9.png";